
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCall = () => {
    window.location.href = 'tel:+14384081200';
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/logo_netyxpro.jpg"
              alt="NetyxPro Logo"
              className="h-12 w-auto object-contain mr-3"
            />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/services/residential" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">
              Entretien Résidentiel
            </Link>
            <Link to="/services/commercial" className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer">
              Nettoyage Commercial
            </Link>
            <Link to="/services/laundry" className="text-gray-700 hover:text-purple-600 font-medium transition-colors cursor-pointer">
              Lessive & Repassage
            </Link>
            <Link to="/services/delivery" className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer">
              Courses & Livraison
            </Link>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact
            </button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/services/residential" 
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Entretien Résidentiel
              </Link>
              <Link 
                to="/services/commercial" 
                className="text-gray-700 hover:text-green-600 font-medium transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Nettoyage Commercial
              </Link>
              <Link 
                to="/services/laundry" 
                className="text-gray-700 hover:text-purple-600 font-medium transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Lessive & Repassage
              </Link>
              <Link 
                to="/services/delivery" 
                className="text-gray-700 hover:text-orange-600 font-medium transition-colors cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                Courses & Livraison
              </Link>
              <button 
                onClick={() => {
                  scrollToSection('contact');
                  setIsMenuOpen(false);
                }}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors text-left whitespace-nowrap cursor-pointer"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}